export default __webpack_public_path__ + "static/media/pictogram-alert-icon.6b49702d.svg";